export const MONEY_GUID_PRO = 'MONEY_GUID_PRO';
export const clearCache = `${MONEY_GUID_PRO}-CLEAR-CACHE`;
export const summaryReducerPrefix = `${MONEY_GUID_PRO}-SUMMARY`;
export const insuranceReducerPrefix = `${MONEY_GUID_PRO}-INSURANCE`;
export const goalsReducerPrefix = `${MONEY_GUID_PRO}-GOALS`;
export const netWorthReducerPrefix = `${MONEY_GUID_PRO}-NET_WORTH`;
export const refreshPrefix = `${MONEY_GUID_PRO}-REFRESH`;

export const refreshEndpointKeyMap = {
  Summary: 'summary',
  Goals: 'goals',
  Insurance: 'insurance',
  NetWorth: 'netWorth',
};

/** How often the MGP page polls /WarmupStatus while login-triggered pre-cache is running (ms). */
export const MGP_WARMUP_POLL_INTERVAL_MS = 4000;

/** Consecutive WarmupStatus fetch failures before falling back to cached tab data. */
export const MGP_WARMUP_STATUS_MAX_RETRIES = 3;

/** Stop polling and fall back to cached tab data after this duration (ms). */
export const MGP_WARMUP_TIMEOUT_MS = 90000;

export const MGP_WARMUP_LOADING_TEXT = "We're updating your data…";
